<template>
  <vue-content-loading v-bind="$attrs" :width="600" :height="225">
    <rect x="0" y="0" rx="3" ry="3" width="200" height="250" />
    <rect x="220" y="0" rx="2" ry="2" width="350" height="45" />
    <rect x="220" y="100" rx="2" ry="2" width="300" height="45" />
    <rect x="220" y="175" rx="2" ry="2" width="200" height="45" />
  </vue-content-loading>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'aggregates_loader',
  components: {
    VueContentLoading,
  },
};
</script>

<style scoped>

</style>
